module.exports = __webpack_public_path__ + "img/Turkmenistan.caff5680.gif";